import { useSelector } from 'react-redux';
import { Button, Grid, GridColumn, Header, Segment } from 'semantic-ui-react';
import { StoreState } from '../../types/state';
import { getLocalTime, timestampColumns } from '../../utils';

type EntityDataProps = {
  entity: { [key: string]: any };
  enableEdit?: boolean;
  onEdit?: () => void;
};

const EntityData = (props: EntityDataProps) => {
  const { entity, enableEdit, onEdit } = props;
  const timezone = useSelector((state: StoreState) => state.auth.timezone);

  if (!entity) return null;
  return (
    <Segment style={{ minHeight: 200 }}>
      <Grid doubling columns={6} divided>
        {Object.keys(entity).map((key) => {
          const isArray = Array.isArray(entity[key]);

          return (
            <GridColumn key={key} style={{ wordWrap: 'break-word' }}>
              <Header>{key}</Header>
              {isArray ? (
                <div className="cell-array">
                  {entity[key].map((val) => (
                    <p key={val}>{val}</p>
                  ))}
                </div>
              ) : (
                <div>
                  {timestampColumns.includes(key) && timezone !== 'UTC'
                    ? getLocalTime(entity[key])
                    : entity[key] === false
                    ? 'false'
                    : entity[key] && entity[key].toString()}
                </div>
              )}
            </GridColumn>
          );
        })}
        {enableEdit ? (
          <GridColumn>
            <Button onClick={onEdit}>Edit</Button>
          </GridColumn>
        ) : null}
      </Grid>
    </Segment>
  );
};

export default EntityData;
